export default "__VITE_ASSET__DNkijVug__"